<script setup lang="ts">
interface Props {
  width?: number | string
  height?: number | string
  iconColor?: string
}

const { width = 33, height = 33, iconColor = 'white' } = defineProps<Props>()
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :aria-label="'Gallery arrow icon'"
    role="img"
  >
    <rect
      x="0.868421"
      y="0.868421"
      width="31.2632"
      height="31.2632"
      rx="15.6316"
      fill="black"
      fill-opacity="0.2"
    />
    <rect
      x="0.868421"
      y="0.868421"
      width="31.2632"
      height="31.2632"
      rx="15.6316"
      :stroke="iconColor"
      stroke-width="1.73684"
    />
    <path
      d="M20.5877 17.1141C20.9269 16.7749 20.9269 16.2251 20.5877 15.8859L15.0611 10.3593C14.722 10.0202 14.1721 10.0202 13.833 10.3593C13.4938 10.6985 13.4938 11.2483 13.833 11.5875L18.7455 16.5L13.833 21.4125C13.4938 21.7517 13.4938 22.3015 13.833 22.6407C14.1721 22.9798 14.722 22.9798 15.0611 22.6407L20.5877 17.1141ZM19.1052 16.5L19.1052 17.3684L19.9736 17.3684L19.9736 16.5L19.9736 15.6316L19.1052 15.6316L19.1052 16.5Z"
      :fill="iconColor"
    />
    <rect x="19.1052" y="15.6309" width="0.868421" height="1.73684" :fill="iconColor" />
  </svg>
</template>

<style scoped></style>
